
$(document).ready(function () {  
    /**
     * Tabs/accordion (desktop/mobile)
     */
    // let $tabArea = $('.tab_area');
    // if($tabArea.length) {
    //     $tabArea.on('click', '.tab_controls a:not(.active)', function (e) {
    //         e.preventDefault();
    //         let id = $(this).attr('data-id');
    //         if(id) {
    //             $(this).parent().find('.active').removeClass('active');
    //             $(this).addClass('active');

    //             let $parent = $(this).closest('.tab_area');
    //             $parent.find('.tab_content:not(#'+id+')').fadeOut(200, function () {
    //                 $parent.find('#'+id).fadeIn(200);
    //             });

    //             $('.tab_header.open').removeClass('open');
    //             $parent.find('#'+id).prev('.tab_header').addClass('open');
    //         } else {
    //             console.warn('Please set "data-id"!')
    //         }
    //     });
    // }
    // $('.tab_header').on('click', function() {
    //     $(this).siblings('.tab_controls').find('.active').removeClass('active');
    //     $(this).siblings('.tab_controls').find('[data-id="' + $(this).next('.tab_content').attr('id') + '"]').addClass('active');

    //     $(this).siblings('.tab_header.open').next('.tab_content').slideUp(200);
    //     $(this).siblings('.tab_header.open').removeClass('open');

    //     $(this).toggleClass('open');
    //     $(this).next('.tab_content').slideToggle(200);
    // });

    $('form.add_form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            submitHandler: function (form) {
                console.log('ok');
                changeStep($(form).closest('.tab_content'), $(form).closest('.tab_content').next().next('.tab_content'));
            }
        });
    });

    $('form.add_url').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            rules: {
                url: {
                  url: true
                }
            },
            submitHandler: function (form) {
                $(form).find('[type=submit]').attr('disabled', true);
                var url = $(form).attr('action');
                var data = $(form).serialize();
                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: data
                });
                req.done(function(resp) {
                    if (resp.success) {
                        if (resp.file) {
                            $('.js-full-file-name').text(resp.file + '.html');
                            $('.js-full-file-name').attr('download', resp.file + '.html');
                            $('.js-download-name').attr('download', resp.file + '.html');
                            $('.js-file-name').text(resp.file_text);
                            if (resp.url) {
                                $('.js-file-url').text(resp.url+'/'+resp.file + '.html');
                                $('.js-file-url').attr('href', resp.url+'/'+resp.file + '.html');
                            }
                        }
                        changeStep($(form).closest('.tab_content'), $(form).closest('.tab_content').next().next('.tab_content'));
                    }
                    $(form).find('[type=submit]').attr('disabled', false);
                })
                req.fail(function(error) {
                    var errors = $.parseJSON(error.responseText);
                    $.each(errors.errors, function(key, value) {
                        $(form).find('input[name='+key+']').addClass('error');
                        $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                    });
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });

    $('form.add_form_file').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            submitHandler: function (form) {
                $(form).find('[type=submit]').attr('disabled', true);
                var url = $(form).attr('action');
                var data = $(form).serialize();
                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: data
                });
                req.done(function(resp) {
                    if (resp.success) {
                        changeStep($(form).closest('.tab_content'), $(form).closest('.tab_content').next().next('.tab_content'));
                    }
                    $(form).find('[type=submit]').attr('disabled', false);
                })
                req.fail(function(error) {
                    var errors = $.parseJSON(error.responseText);
                    $(form).find('.message_error').show();
                    $.each(errors.errors, function(key, value) {
                        $(form).find('input[name='+key+']').addClass('error');
                        $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                    });
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });

    $('#confirmEmail a.btn').on('click', function () {
        $('form#for-email-form').submit();
    })

    $('form#for-email-form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            submitHandler: function (form) {
                $(form).find('[type=submit]').attr('disabled', true);
                var url = $(form).attr('action');
                var data = $(form).serialize();
                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: data
                });
                req.done(function(resp) {
                    if (resp.success) {
                        changeStep($(form).closest('.tab_content'), $(form).closest('.tab_content').next().next('.tab_content'));
                    }
                })
                req.fail(function(error) {
                    var errors = $.parseJSON(error.responseText);
                    $.each(errors.errors, function(key, value) {
                        $(form).find('input[name='+key+']').addClass('error');
                        $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                    });
                });
                req.always(function(error) {
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });
    
    /**
     * Go to next step
     */
    function changeStep(from, to) {
        let $from = $(from),
            $to = $(to);

        //Set class to top buttons
        let $steps = $('.tab_controls');
        $steps.find('[data-id="' + from.attr('id') + '"]').removeClass('active')
            .addClass('edit');
        $steps.find('[data-id="' + to.attr('id') + '"]').removeClass('edit disabled')
            .addClass('active');
            
        $('[id="' + from.attr('id') + '"]').prev('.tab_header').removeClass('active')
            .addClass('edit');
        $('[id="' + to.attr('id') + '"]').prev('.tab_header').removeClass('edit disabled')
            .addClass('active');

        if($(window).width() >= 768) {
            $from.fadeOut(200, function () {
                $to.fadeIn(200, function () {
                    // $('html, body').stop().animate({
                    //     'scrollTop': $('.tab_controls').offset().top - 50
                    // }, 200);
                });
            });
        } else {
            $from.slideUp(0, function () {
                $to.slideDown(200, function () {
                //     $('html, body').stop().animate({
                //         'scrollTop': $('.tab_controls').offset().top - 100
                //     }, 200);
                });
            });
        }
    }

    /**
     * Edit block
     */
    function editStep() {
        $('.tab_controls').on('click', '.edit', function (e) {
            e.preventDefault();
            let $this = $(this),
                from = $('.tab_controls .active').attr('data-id'),
                to = $this.attr('data-id');

            let $closeBl = $('#' + from);
            if (validCloseBlock($closeBl)) {
                changeStep($('#' + from), $('#' + to));
            }
        });
        $('.tab_area').on('click', '.tab_header.edit', function (e) {
            e.preventDefault();
            let $this = $(this).next('.tab_content'),
                from = $('.tab_controls .active').attr('data-id'),
                to = $this.attr('id');

            let $closeBl = $('#' + from);
            if (validCloseBlock($closeBl)) {
                changeStep($('#' + from), $('#' + to));
            }
        });
    }

    editStep();

    /**
     * Validate block`s forms before close
     */
    function validCloseBlock($element) {
        let result = true;

        let $visibleForm = $element.attr('id') == 'confirm-block' ? $element.find('.accordion-body form') : $element.find('form');
        $visibleForm.each(function () {
            if($element.attr('id') == 'confirm-block' && $(this).closest('.accordion-body').css('display') !== 'none') {
                if ($(this).valid()) {
                    result = true;
                    return false;
                } else {
                    result = false;
                    return false;
                }
            } 
            else if ($element.attr('id') !== 'confirm-block') {
                if ($(this).valid()) {
                    result = true;
                    return false;
                } else {
                    result = false;
                    return false;
                }
            }
        });
        return result;
    }

    function copyToClipboard(element) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(element).val()).select();
        document.execCommand("copy");
        $temp.remove();
    }

    $('.copy-button').click(function() { 
        copyToClipboard('#verification');
    });

    $('.js-site-country ul li').on('click', function () {
        var id = $(this).attr('data-id');
        var url = $('.js-site-country').attr('data-action');
        $('.js-site-country').find('input[name=country_id]').val(id);
        
        $('.selected_filter_list ul').find('li:not(.country-item)').each(function(){
            $(this).find('.icon-close').trigger('click');
        });
        
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'country_id': id, '_token': CSRF_TOKEN},
        });
        req.done(function (resp) {
            if (resp.success) {
                $('.js-site-regions').find('.js-regions-list').remove();
                if (resp.count) {
                    $('.js-site-regions').removeClass('disabled');
                } else {
                    $('.js-site-regions').addClass('disabled');
                }
                if (resp.html) {
                    $('.js-site-regions').append(resp.html);
                }
                if ($('.js-site-regions').attr('data-selected')) {
                    var selectedRegions = JSON.parse($('.js-site-regions').attr('data-selected'));
                    if (selectedRegions) {
                        for (var i = 0; i < selectedRegions.length; i++) {
                            $('.js-site-regions input:checkbox[value="' + selectedRegions[i] + '"]').click();
                        }
                    }
                    $('.js-site-regions').attr('data-selected', '');
                }
            }
        });
    });

    function getSiteCities(){
    // $('.js-site-regions').on('click', 'input:checkbox', function () {
        var country_id = $('.js-site-country').find('input[name=country]').val();
        var region_ids = $('.js-site-regions').find('input:checked').map(function(i, el){
            return $(el).val();
        }).get();
        var url = $('.js-site-regions').attr('data-action');
        var req = $.ajax({
            method: 'post',
            url: url+'?json',
            data: {'region_ids': region_ids, '_token': CSRF_TOKEN},
        });
        req.done(function (resp) {
            if (resp.success) {
                $('.js-site-cities').find('.js-cities-list').remove();
                var allCitiesText =  $('.js-site-cities').attr('data-allcheck');
                var nothingFoundText = $('.js-filter-cities').attr('data-nothing');
                var placeholderText = $('.js-filter-cities').attr('data-placeholder');
                var data;

                var div_dd = document.createElement('div');
                div_dd.classList = 'drop_down-list js-cities-list';

                var div_scrollbar = document.createElement('div');
                div_scrollbar.classList = 'custom_scrollbar_y';

                div_dd.appendChild(div_scrollbar);

                var p_empty = document.createElement('p');
                p_empty.classList = 'empty';
                p_empty.style.display = 'none';
                p_empty.textContent = nothingFoundText;

                div_scrollbar.appendChild(p_empty);

                var div_fg = document.createElement('div');
                div_fg.classList = 'form-group search-group';
                div_fg.innerHTML = '<input type="text" class="search_box" placeholder="' + placeholderText + '"><i class="icon-search"></i>';

                div_dd.prepend(div_fg);

                var ul = document.createElement('ul');

                ul.innerHTML = '<li class="allcities checkbox-group"><label><input type="checkbox" class="allcheck" data-value="default" id="cities_all" name="cities[]" value="cities_all" >' + allCitiesText + '</label></li>';

                for (var region in resp.cities) {
                  data = resp.cities[region];

                  for (var i in data) {
                    var input = document.createElement('input');
                    var label = document.createElement('label');
                    var li = document.createElement('li');
                    li.classList = 'checkbox-group';
                    input.type = "checkbox";
                    input.value = i;
                    input.name = 'cities[]';
                    input.id = 'region'+[region]+'city'+[i];
                    label.textContent = data[i];
                    label.appendChild(input);
                    li.appendChild(label)
                    ul.appendChild(li);
                  }

                }

                div_scrollbar.appendChild(ul);

                $('.js-site-cities').append(div_dd);
                if (resp.count) {
                    $('.js-site-cities').removeClass('disabled');
                }
                if (resp.html) {
                    $('.js-site-cities').append(resp.html);
                }
                if ($('.js-site-cities').attr('data-selected')) {
                    var selectedCities = JSON.parse($('.js-site-cities').attr('data-selected'));
                    if (selectedCities) {
                        for (var i = 0; i < selectedCities.length; i++) {
                            $('.js-site-cities input:checkbox[value="' + selectedCities[i] + '"]').click();
                        }
                    }
                    $('.js-site-cities').attr('data-selected', '');
                }
                
                if($(window).width() > 1024) {
                    $('.custom_scrollbar_y').mCustomScrollbar({
                        theme: "minimal-dark",
                        autoHideScrollbar: false,
                        scrollInertia: 0
                    });
                }
            }
        });
    // });
    }
    
    var $regionDropDownSite = $(".js-site-regions");
    $regionDropDownSite.find(' > .select').on('click', function () {
        if($regionDropDownSite.hasClass('changed') && $regionDropDownSite.hasClass('regions-closed') && $regionDropDownSite.find('input:checked').length > 0) {
            getSiteCities();
            $regionDropDownSite.removeClass('changed');
            $regionDropDownSite.removeClass('regions-closed');
        }
    });
    $(document).on('mouseup', function (e) {
        if ($regionDropDownSite.has(e.target).length === 0 && !$('.icon-close').is(e.target)) {
            if($regionDropDownSite.hasClass('changed') && $regionDropDownSite.hasClass('regions-closed') && $regionDropDownSite.find('input:checked').length > 0) {
                getSiteCities();
                $regionDropDownSite.removeClass('changed');
                $regionDropDownSite.removeClass('regions-closed');
            }
        }
    });

    if ($('.js-site-country ul li[selected]').length) {
        $('.js-site-country ul li[selected]').click();
    }
    if ($('.js-site-country ul li.active').length) {
        $('.js-site-country ul li.active').click();
    }

    $('.js-site-links-count ul li').on('click', function () {
        var count = $(this).attr('data-count');
        $('.js-site-links-count').find('input[name=links_count]').val(count);
    });
    if ($('.js-site-links-count ul li.active').length) {
        $('.js-site-links-count ul li.active').click();
    }

    $('.js-site-text-limit ul li').on('click', function () {
        var count = $(this).attr('data-count');
        $('.js-site-text-limit').find('input[name=text_limit]').val(count);
    });
    if ($('.js-site-text-limit ul li.active').length) {
        $('.js-site-text-limit ul li.active').click();
    }

    $('.js-site-images-count ul li').on('click', function () {
        var count = $(this).attr('data-count');
        $('.js-site-images-count').find('input[name=links_count]').val(count);
    });
    if ($('.js-site-images-count ul li.active').length) {
        $('.js-site-images-count ul li.active').click();
    }

    $('form.js-add-site-form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            ignore: ':hidden:not(.validate)',
            focusInvalid: false,
            invalidHandler: function(form, validator) {
                if (!validator.numberOfInvalids())
                    return;
                if(!$(validator.errorList[0].element).closest('.wrap_popup').length) {
                    if($(validator.errorList[0].element).attr('type') === 'hidden' && $(validator.errorList[0].element).closest('.form-group').length) {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).closest('.form-group').offset().top - 120
                        }, 500);
                    } else {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).offset().top - 120
                        }, 500);
                    }
                    $(validator.errorList[0].element).focus();
                }
            },
            submitHandler: function (form) {
                $(form).find('[type=submit]').attr('disabled', true);
                var data = $(form).serializeArray();
                var url = $(form).attr('action');

                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: data,
                });
                req.done(function(resp) {
                    if (resp.success) {
                        if (resp.href) {
                            location.href = resp.href;
                        }
                    }
                })
                req.fail(function(error) {
                    var errors = $.parseJSON(error.responseText);
                    $.each(errors.errors, function(key, value) {
                        if (key == 'country_id') {
                            $(form).find('.js-site-country').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                        } else if (key == 'prices') {
                            $(form).find('.js-price-prices').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                        } else if (key == 'services') {
                            $(form).find('.js-price-services').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                        }else {
                            $(form).find('input[name="' + key + '"]').addClass('error');
                            $(form).find('input[name="' + key + '"]').after('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                        }
                    });
                });
                req.always(function() {
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });

    function checkVisibleInput($this) {
        if($this.find('input[type="checkbox"]').is(':checked')) {
            $this.next('.form-group').slideDown(100);
        } else {
            $this.next('.form-group').slideUp(100);
            $this.next('.form-group').find('input').val('');
        }
    }
    $('.add-cost-input').each(function() {
        checkVisibleInput($(this));
    });

    $('.add-cost-input').on('change', 'input[type="checkbox"]', function() {
        checkVisibleInput($(this).closest('.add-cost-input'));
    });
    
    function checkVisibleCalendar($this) {
        if($this.find('input[type="checkbox"]').is(':checked')) {
            $this.next('.with-calendar').slideDown(100).css('display', 'flex');
        } else {
            $this.next('.with-calendar').slideUp(100);
        }
    }
    $('.show-calendar').each(function() {
        checkVisibleCalendar($(this));
    });

    $('.show-calendar').on('change', 'input[type="checkbox"]', function() {
        checkVisibleCalendar($(this).closest('.show-calendar'));
    });

    $('input:not([type="email"]):not([type="file"]):not([type="radio"])').on('focus', function() {
        var that = this;
        setTimeout(function(){ that.selectionStart = that.selectionEnd = 10000; }, 0);
    });
    $(".add_url #url").trigger('focus');
});